import React from "react";
import {
	PageBanner,
	BigHeading,
	Lineup,
	Tickertape,
	ButtonGrid,
} from "../components";
import { Helmet } from "react-helmet";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link, graphql } from "gatsby";
import { tw } from "../tw";
import BlockContent from "@sanity/block-content-to-react";
import { format } from "date-fns";

const kebabCase = (string) => {
	return string
		.replace(/\s+/g, "-")
		.toLowerCase()
		.replace(/[^a-zA-Z0-9-_]/g, "");
};

/* Blog Page
============================================================================= */

const BlogPage = ({ data }) => {
	// Config

	const renderBlogPosts = () => {
		return data.allSanityBlog.nodes.map((blog) => {
			return <BlogListingItem blog={blog} />;
		});
	};

	// Render
	return (
		<>
			<Helmet>
				<title>Blog</title>
			</Helmet>
			<PageBanner />
			<Tickertape />
			<BigHeading text="Blog" />
			<div
				className={
					"mb-8 grid md:grid-cols-2 grid-cols-1 gap-6 container mx-auto pt-12 relative z-50"
				}
			>
				{renderBlogPosts()}
			</div>
		</>
	);
};

/* Blog Listing Item
============================================================================= */

const BlogListingItem = ({ blog }) => {
	const date = blog._createdAt;
	return (
		<div className="col-span-1 bg-gtgreen p-6 rounded-md shadow-xl">
			<div class="">
				<div class="relative max-w-lg mx-auto  lg:max-w-7xl flex items-start justify-start">
					<div className="relative w-40 h-40 mr-6">
						<GatsbyImage
							objectFit="cover"
							objectPosition="50% 50%"
							className="w-40 h-40"
							image={blog.banner_image.asset.gatsbyImageData}
						/>
					</div>
					<div class="grid gap-16 lg:grid-cols-1 lg:gap-x-5 lg:gap-y-12">
						<div>
							<p class="text-sm text-white">
								<time
									datetime={format(
										new Date(date),
										"dd-mm-yy"
									)}
								>
									{format(new Date(date), "MMM dd, yyyy")}
								</time>
							</p>
							<a href="#" class="mt-2 block">
								<p class="text-xl font-bold text-white">
									{blog.title}
								</p>
								<p class="mt-3 text-base text-white">
									{blog.summary}
								</p>
							</a>
							<div class="mt-3">
								<Link
									to={`/blogs/${kebabCase(blog.title)}`}
									class="text-base font-bold underline text-white"
								>
									Read full article
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

/* Page Query
============================================================================= */

export const pageQuery = graphql`
	query BlogPageQuery {
		allSanityBlog {
			nodes {
				title
				summary
				banner_image {
					asset {
						gatsbyImageData(
							width: 2048
							placeholder: BLURRED
							formats: [AUTO, WEBP, AVIF]
						)
					}
				}
				_rawContent(resolveReferences: { maxDepth: 10 })
				_createdAt
			}
		}
	}
`;

/* Export
============================================================================= */

export default BlogPage;
